var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"toggle",attrs:{"name":_vm.name,"type":"checkbox","data-toggle":"toggle","data-onstyle":_vm.onStyle,"data-offstyle":_vm.offStyle,"data-on":_vm.onLabel,"data-off":_vm.offLabel,"data-size":_vm.size},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.onChange()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }